import { Flex } from 'antd';
import React, { useState } from 'react';

import useDynamicSelector from '../../hooks/useDynamicSelector';
import { ListItemType } from '../../types';
import ListItemEditButton from './listItemEditButton';

interface IListItemOption {
    item: ListItemType;
    readonly?: boolean;
    connectionId: string;
}

const ListItemOption: React.FC<IListItemOption> = ({ item, readonly, connectionId }) => {
    const editMode = useDynamicSelector('listItem', 'editMode');

    const [hoveredItemId, setHoveredItemId] = useState<number | null>(null);

    const text = `${item.name}${item.code ? ' (' + item.code + ')' : ''}`;

    const handleMouseEnter = (itemId: number) => {
        if (editMode !== 'deleting') {
            setHoveredItemId(itemId);
        }
    };

    const handleMouseLeave = () => {
        if (editMode !== 'deleting') {
            setHoveredItemId(null);
        }
    };

    const isVisible = !readonly && hoveredItemId === item.id;

    return (
        /* <Tooltip title={item.description} placement="top"> */
        <Flex justify={'space-between'} onMouseEnter={() => handleMouseEnter(item.id)} onMouseLeave={handleMouseLeave}>
            <span
                style={{
                    width: isVisible ? 'calc(100% - 55px)' : 'auto',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
            >
                {text}
            </span>
            {isVisible && (
                <div
                    onMouseEnter={() => handleMouseEnter(item.id)}
                    // onMouseLeave={handleMouseLeave}
                    style={{ height: 22, position: 'absolute', right: 10 }}
                >
                    <ListItemEditButton item={item} connectionId={connectionId} />
                </div>
            )}
        </Flex>
        /* </Tooltip> */
    );
};

export default ListItemOption;
